module.exports = __webpack_public_path__ + "static/media/landing.a59f30d5.jpg";